export { default } from './PageLegalDetail'
